const Status = ({ busy, online, status, orders }) => {
  switch (true) {
    case !status:
      return <span className="badge text-white bg-danger">Suspended</span>;
    case busy:
      return Array.isArray(orders) && orders?.length > 0 ? (
        orders?.some((o) => o?.status === "5") ? (
          <span className="badge text-white bg-success">En Route</span>
        ) : (
          <span className="badge text-white bg-primary">Pickup</span>
        )
      ) : (
        <span className="badge text-white bg-warning">Busy</span>
      );

    case !busy && online && status:
      return <span className="badge text-white bg-success">Online</span>;

    case !busy && !online && status:
      return <span className="badge text-white bg-danger">Offline</span>;

    default:
      return <span>---</span>;
  }
};

export default Status;
